// extracted by mini-css-extract-plugin
module.exports = {"headerDiv":"Header_headerDiv__1iFGn"};